import {z} from 'zod';

/**
 * Request schema for getting usage summary by usage ID with optional date filtering
 */
export const getUsageSummaryRequestSchema = z.object({
  usageId: z.string(),
  createdAtFrom: z.coerce.date().optional(),
  createdAtTo: z.coerce.date().optional(),
});

export type GetUsageSummaryRequest = z.infer<typeof getUsageSummaryRequestSchema>;
